import { ICrisisStore } from './types';

const initStore: ICrisisStore = {
  current: null,
  allocatedClients: [],
  crisisCalls: [],
};

export default initStore;
